// components/InlineAddBtn.jsx
import React from "react";
import { FiPlus } from "react-icons/fi";
import "./InlineAddBtn.scss";

// Standard button props (onClick, disabled, title, aria-label…) pass through.
export default function InlineAddBtn({
  children,
  circleSize = 40,
  iconSize = 20,
  gap = 10,
  fontSize,
  className = "",
  style,
  ...buttonProps
}) {
  return (
    <button
      {...buttonProps}
      type="button"
      className={`inline-add-btn ${className}`}
      style={{
        "--add-circle-size": `${circleSize}px`,
        gap,
        fontSize,
        ...style,
      }}
    >
      <span className="inline-add-btn__circle" aria-hidden="true">
        <FiPlus size={iconSize} />
      </span>
      <span>{children}</span>
    </button>
  );
}
